import { createListenerMiddleware } from "@reduxjs/toolkit";
import axiosInstance, { atgAxiosInstance } from "../../api/axiosInstance";

export const networkMiddleware = createListenerMiddleware();

// Login/onboarding endpoints may return 403 for business reasons (deleted user,
// pending approval) — not session expiry. Do not force-logout on those.
const AUTH_FLOW_403_EXEMPT_SEGMENTS = [
  "send-login-otp",
  "verify-login-otp",
  "oauth-auth-code-login",
  "send-otp",
  "/login",
  "feedback/submit",
];

const isAuthFlow403Exempt = (error) => {
  const url = error?.config?.url || "";
  return AUTH_FLOW_403_EXEMPT_SEGMENTS.some((segment) => url.includes(segment));
};

const performLogout = () => {
  [localStorage, sessionStorage].forEach((storage) => {
    storage.removeItem("authToken");
    storage.removeItem("Token");
    storage.removeItem("user_type");
    storage.removeItem("admin-brand");
    storage.removeItem("admin-onboarding-brand");
  });

  window.location.href = "/login";
};

export const handle403Error = () => {
  console.warn("403 Unauthorized access detected. Logging out user...");
  performLogout();
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403 && !isAuthFlow403Exempt(error)) {
      handle403Error();
    }
    return Promise.reject(error);
  },
);

atgAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403 && !isAuthFlow403Exempt(error)) {
      handle403Error();
    }
    return Promise.reject(error);
  },
);

export default networkMiddleware;
